const styledIconsMap: Partial<Record<string, string>> = {
	docx: "bi-file-earmark-word text-primary",
	xlsx: "bi-file-earmark-spreadsheet text-success",
	pptx: "bi-file-earmark-slides text-danger",
	txt: "bi-file-earmark-text text-muted",
	png: "bi-file-earmark-image text-warning",
	jpg: "bi-file-earmark-image text-warning",
	pdf: "bi-file-earmark-pdf text-danger",
	zip: "bi-file-earmark-zip text-muted",
};

const iconFiletypes = [
	"aac",
	"ai",
	"bmp",
	"cs",
	"css",
	"csv",
	"doc",
	"docx",
	"exe",
	"gif",
	"heic",
	"html",
	"java",
	"jpg",
	"js",
	"json",
	"jsx",
	"key",
	"m4p",
	"md",
	"mdx",
	"mov",
	"mp3",
	"mp4",
	"otf",
	"pdf",
	"php",
	"png",
	"ppt",
	"pptx",
	"psd",
	"py",
	"raw",
	"rb",
	"sass",
	"scss",
	"sh",
	"sql",
	"svg",
	"tiff",
	"tsx",
	"ttf",
	"txt",
	"wav",
	"woff",
	"xls",
	"xlsx",
	"xml",
	"yml",
];

export default function getFileIconCss(extension: string) {
	const styledIcon = styledIconsMap[extension];

	if (styledIcon) return styledIcon;

	if (iconFiletypes.includes(extension)) {
		return `bi-filetype-${extension} text-muted`;
	}

	return "bi-file-earmark text-muted";
}
